export const common = {
  clinicName: 'Clinique Rihane',
  home: 'Accueil',
  services: 'Services',
  about: 'À Propos',
  news: 'Actualités',
  gallery: 'Galerie',
  contact: 'Contact',
  recruitment: 'Recrutement',
  weAreHiring: 'Nous Recrutons',
  callUs: 'Contactez-nous',
  makeAppointment: 'Prendre Rendez-vous',
  ourServices: 'Nos Services',
  sendMessage: 'Envoyer le Message',
  sending: 'Envoi en cours...',
  submit: 'Envoyer',
  required: 'Obligatoire',
  
  hero: {
    title: 'Clinique Rihane',
    subtitle: 'Premier Établissement de Santé Privé Moderne de Jijel',
    description: 'Technologies de pointe et équipe médicale qualifiée pour votre bien-être',
    emergencies: 'Urgences Disponibles',
    qualifiedTeam: 'Équipe Qualifiée',
    qualifiedTeamDesc: 'Médecins spécialistes expérimentés',
    modernEquipment: 'Équipements Modernes',
    modernEquipmentDesc: 'Technologies de dernière génération'
  },
  
  aboutSection: {
    title: 'À Propos de la Clinique Rihane',
    description1: 'La Clinique Rihane est le premier établissement de santé privé moderne de Jijel, offrant des services médicaux de haute qualité dans un environnement confortable et sécurisé. Fondée avec la vision de transformer les soins de santé dans la région, notre clinique s\'engage à fournir des services médicaux accessibles et de qualité supérieure à tous nos patients.',
    description2: 'Située au Lotissement Haine Rachid (Belhaine), notre clinique combine technologies de pointe et équipe médicale qualifiée pour garantir les meilleurs soins à nos patients. Nous disposons d\'équipements médicaux modernes incluant un scanner de dernière génération, des appareils d\'échographie avancés, et un laboratoire d\'analyses complet. Notre équipe multidisciplinaire de médecins spécialistes et de personnel soignant dévoué travaille ensemble pour offrir une prise en charge globale et personnalisée.',
    description3: 'Notre engagement envers l\'excellence se reflète dans chaque aspect de nos services : de l\'accueil chaleureux de nos patients à la qualité de nos soins médicaux, en passant par le confort de nos installations. Nous croyons fermement que chaque patient mérite une attention particulière et des soins adaptés à ses besoins spécifiques.',
    medicalExcellence: 'Équipe Médicale Qualifiée',
    medicalExcellenceDesc: 'Équipe de médecins spécialistes hautement qualifiés et expérimentés',
    advancedTech: 'Technologies Avancées',
    advancedTechDesc: 'Équipements médicaux de dernière génération : scanner, échographie, laboratoire',
    availability: 'Disponibilité Continue',
    availabilityDesc: 'Service d\'urgences ouvert pour tous vos besoins médicaux',
    emergencies: 'Urgences',
    specialties: 'Spécialités',
    dedicated: 'Dévoués'
  },
  
  contactSection: {
    title: 'Contactez-Nous',
    subtitle: 'Notre équipe est disponible pour répondre à vos questions',
    info: 'Informations de Contact',
    address: 'Adresse',
    addressValue: 'Lotissement Haine Rachid (Belhaine), Jijel 18000, Algérie',
    phones: 'Téléphones',
    whatsapp: 'WhatsApp',
    whatsappDesc: '(Réservations et informations)',
    email: 'Email',
    hours: 'Horaires',
    hoursEmergency: 'Urgences : Disponibles',
    hoursConsultation: 'Consultations : Sur rendez-vous',
    followUs: 'Suivez-nous',
    sendMessageTitle: 'Envoyez-nous un Message',
    fullName: 'Nom Complet',
    phone: 'Téléphone',
    subject: 'Sujet',
    selectSubject: 'Sélectionnez un sujet',
    appointment: 'Prise de rendez-vous',
    emergency: 'Urgence médicale',
    information: 'Renseignements',
    results: 'Résultats d\'analyses',
    other: 'Autre',
    message: 'Message',
    messagePlaceholder: 'Décrivez votre demande... (500 caractères maximum)',
    characters: 'caractères',
    successMessage: '✓ Message envoyé avec succès !',
    errorMessage: '✗ Une erreur s\'est produite. Veuillez réessayer.'
  },
  
  footer: {
    description: 'Premier établissement de santé privé moderne de Jijel. Technologies de pointe et équipe médicale qualifiée.',
    quickLinks: 'Liens Rapides',
    ourServices: 'Nos Services',
    contactInfo: 'Contact',
    emergencies: 'Urgences : Disponibles',
    consultations: 'Consultations : Sur RDV',
    rights: 'Tous droits réservés.',
    poweredBy: 'Powered by Readdy',
    services: {
      emergencies: 'Urgences Médicales',
      consultations: 'Consultations',
      imaging: 'Imagerie Médicale',
      gynecology: 'Gynécologie-Obstétrique',
      surgery: 'Chirurgie',
      laboratory: 'Laboratoire',
      hospitalization: 'Hospitalisation'
    }
  }
};
